import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions  } from '@angular/http';
import { Router } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

import { ApiSettings } from '../../api.settings';


@Injectable()
export class AuthService {

  private authUrl = ApiSettings.API_URL + 'login';
  private isLoggedInUrl = ApiSettings.API_URL + 'isloggedin';
  private logoutUrl = ApiSettings.API_URL + 'logout';
  private headers = new Headers({ 'Content-Type': 'application/json' });
  private options = new RequestOptions({ headers: this.headers, withCredentials: true});

  constructor(private http: Http, private router: Router) { }

  login(user: any): Observable<any> {
    return this.http.post(this.authUrl, { username:user.username, password: user.password}, this.options)
                    .map(this.extractData)
                    .catch(this.handleError.bind(this));
  }

  isLoggedIn(): Observable<any> {
    return this.http.get(this.isLoggedInUrl, this.options)
                    .map(this.extractData)
                    .catch(this.handleError.bind(this));
  }

  logout(): Observable<any> {
    localStorage.removeItem('user');
    localStorage.removeItem('shop');
    return this.http.get(this.logoutUrl, this.options)
                    .map(this.extractData)
                    .catch(this.handleError.bind(this));
  }


  private extractData(res: Response) {
    let body = res.json();
    return body || { };
  }
  
  private handleError (error: Response | any) {
    if (error.status === 403){
      this.router.navigate(['/login']);
    }
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/services/auth.service.ts